import { useDispatch } from 'react-redux';
import { Col, Alert, Spinner, Badge } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { createSelector } from 'reselect';
import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import { getGuideList } from '../../../../slices/thunks';
import { Link } from 'react-router-dom';
import { ODataGrid } from '../../../../Components/OElements/ODataGrid';
import ResiduesList from '../../Residues/ResiduesList';
import ConfirmReceptionFinalDestinationModal from './Modals/ConfirmReceptionFinalDestinationModal';
import { setRequireCloseModal, setRequireReloadSelectionItemsGrid } from '../../../../slices/guide/reducer';
import GuideDetail from '../../Guides/GuideDetail';
import EditKilogramsReceivedModal from './Modals/EditKilogramsReceivedModal';
import { toast } from 'react-toastify';

const ReceptionGuide = () => {
	const dispatch = useDispatch();
	const history = useNavigate();

	const selectorGuides = createSelector(
		state => state.Guides,
		guide => ({
			guideList: guide.guideList,
			isLoadingList: guide.isLoadingList,
			isGuideSuccess: guide.isGuideSuccess,
			error: guide.error,
			isAdding: guide.isAdding,
			isAdded: guide.isAdded,
			isAddError: guide.isAddError,
			isUpdating: guide.isUpdating,
			isUpdated: guide.isUpdated,
			isUpdateError: guide.isUpdateError,
			isDeleting: guide.isDeleting,
			isDeleted: guide.isDeleted,
			isDeleteError: guide.isDeleteError,
			requireCloseModal: guide.requireCloseModal,
			requireReloadSelectionItemsGrid: guide.requireReloadSelectionItemsGrid
		})
	);

	const {
		guideList,
		isLoadingList,
		requireCloseModal,
		requireReloadSelectionItemsGrid
	} = useSelector(selectorGuides);

	useEffect(() => {
		dispatch(getGuideList({ reception_final_destination: true }));
	}, []);

	const [dataGuide, setDataGuide] = useState({});
	const [isEdit, setIsEdit] = useState(false);

	// Delete Guide
	const [modal, setModal] = useState(false);
	const [modalDelete, setModalDelete] = useState(false);
	//Tab
	const [activeTab, setActiveTab] = useState('1');
	const toggleTab = tab => {
		if (activeTab !== tab) {
			setActiveTab(tab);
		}
	};

	function handleToggleModal() {
		setModal(!modal);
		toggleTab('1');
		// validation.resetForm();
	}

	function handleToggleModalDelete() {
		setModalDelete(!modalDelete);
	}

	// Delete Data
	const handleClickDelete = guide => {
		setDataGuide(guide);
		setModalDelete(true);
	};

	// Update Data
	const handleClickEdit = guide => {
		setDataGuide(guide);
		handleToggleModal();
	};

	const [modalGuideDetail, setModalGuideDetail] = useState(false);
	const [selectedGuideId, setSelectedGuideId] = useState(null);
	const toggleModal = () => setModalGuideDetail(!modalGuideDetail);
	const handleGuideClick = (guide) => {
		setSelectedGuideId(guide);
		toggleModal();
	};

	const [guideSelectedList, setGuideSelectedList] = useState([])

	const [selectionReceiveList, setSelectionReceiveList] = useState([]);
	const [selectionToReceivedList, setSelectionToReceivedList] = useState([]);

	function handleRemoveGuideSelectionList(guide) {
		let selectionReceiveListToUpdate = selectionReceiveList;
		delete selectionReceiveListToUpdate[guide._id];
		setSelectionReceiveList(selectionReceiveListToUpdate);
		setGuideSelectedList(guideSelectedList.filter(item => item._id != guide._id));
	}

	const [isOpenEditKilogramsReceivedGuideModal, setIsOpenEditKilogramsReceivedGuideModal] = useState(false);

	function handlerToggleEditKilogramsReceivedGuideModal() {
		setIsOpenEditKilogramsReceivedGuideModal(!isOpenEditKilogramsReceivedGuideModal);
	}


	const columnsTableReceive = useMemo(
		() => [
			// {
			// 	header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
			// 	accessorKey: 'guide',
			// 	 size: 'auto',
			// 	Cell: cellProps => {
			// 		return (
			// 			<React.Fragment>
			// 				<div className='d-flex'>
			// 					<div className='flex-shrink-0'>
			// 						<ul className='list-inline mb-0'>
			// 						</ul>
			// 					</div>
			// 				</div>
			// 			</React.Fragment>
			// 		);
			// 	},
			// },
		{
			header: "Guía",
			accessorKey: "guide_number",

			size: "auto",
			Cell: ({ row }) => {
				const displayNumber = row.original.folio || row.original.guide_number || '-';
				return (
					<span 
						onClick={() => handleGuideClick(row.original)} 
						style={{ cursor: "pointer", color: "var(--vz-primary)", textDecoration: "none", fontWeight: "bold" }}
					>
						{displayNumber}
					</span>
				);
			},
		},
			{ header: 'Fecha', accessorKey: 'guide_date', dataType: 'date' },
			// {
			// 	header: 'Estado',
			// 	accessorKey: 'status_guide',
			// 	 size: 'auto',
			// 	Cell: ({ row }) => {
			// 		let status = row.original.status_guide
			// 		let bgColor = status.bgcolor;
			// 		let txColor = status.txcolor;
			// 		return (
			// 			<div className='d-flex align-items-center'>
			// 				<span className={`badge`} style={{ backgroundColor: bgColor, color: txColor }}>
			// 					{row.original.status_guide?.name
			// 						? row.original.status_guide.name
			// 						: ''}
			// 				</span>
			// 			</div>
			// 		);
			// 	},
			// },
			{ header: 'Origen', accessorKey: 'establishment.name', size: 'auto', },
			// {
			// 	header: 'Empresa',
			// 	accessorKey: 'establishment.company.name',
			// 	 size: 'auto',
			// },
			// {
			// 	header: 'Bodega transitoria',
			// 	accessorKey: 'warehouse.name',
			// 	 size: 'auto',
			// },
			{ header: 'Destino Final', accessorKey: 'final_destination.name', size: 'auto', },
			// { header: 'Kg Recibidos', accessorKey: 'kilograms_received',  size: 'auto' },
			{ header: 'Kg por Recibir', accessorKey: 'kilograms_sended', size: 'auto' },
			// { header: 'Kg Recepcionados', accessorKey: 'kilograms_received',  size: 'auto' },
			// { header: 'Kg Certificados', accessorKey: 'kilograms_certified',  size: 'auto' },
			{ header: 'Factura', accessorKey: 'invoce', size: 'auto', visible: false },
			{ header: 'IVA', accessorKey: 'iva', size: 'auto', visible: false },
			{ header: 'Subtotal', accessorKey: 'subtotal', size: 'auto', visible: false },
			{ header: 'Total', accessorKey: 'total', size: 'auto', visible: false },
			{ header: 'Observación', accessorKey: 'observation', size: 'auto', visible: false },
		],
		[handleClickEdit]
	);

	const columnsTableToReceived = useMemo(
		() => [
			{
				header: 'Acciones', enableSorting: false, enableColumnFilter: false, enableGlobalFilter: false, enableColumnActions: false,
				accessorKey: 'guide',
				columnDefType: 'display',
				size: 'auto',
				Cell: cellProps => {
					return (
						<React.Fragment>
							<div className='d-flex'>
								<div className='flex-shrink-0'>
									<ul className='list-inline mb-0'>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const guideData = cellProps.row.original;
													setDataGuide(guideData);
													handlerToggleEditKilogramsReceivedGuideModal();
												}}
											>
												<i className='ri-pencil-fill align-bottom me-2 text-muted' title='Editar kilogramos'></i>
											</Link>
										</li>
										<li className='list-inline-item'>
											<Link
												to='#'
												className='remove-item-btn'
												onClick={() => {
													const guideData = cellProps.row.original;
													handleClickDelete(guideData);
												}}
											>
												<i className='ri-indeterminate-circle-line align-bottom me-2 text-muted' title='Deseleccionar Item'></i>
											</Link>
										</li>
									</ul>
								</div>
							</div>
						</React.Fragment>
					);
				},
			},
		{
			header: "Guía",
			accessorKey: "guide_number",

			size: "auto",
			Cell: ({ row }) => {
				const displayNumber = row.original.folio || row.original.guide_number || '-';
				return (
					<span 
						onClick={() => handleGuideClick(row.original)} 
						style={{ cursor: "pointer", color: "var(--vz-primary)", textDecoration: "none", fontWeight: "bold" }}
					>
						{displayNumber}
					</span>
				);
			},
		},
			{ header: 'Fecha', accessorKey: 'guide_date', dataType: 'date' },
			// {
			// 	header: 'Estado',
			// 	accessorKey: 'status_guide',
			// 	 size: 'auto',
			// 	Cell: ({ row }) => {
			// 		let status = row.original.status_guide
			// 		let bgColor = status.bgcolor;
			// 		let txColor = status.txcolor;
			// 		return (
			// 			<div className='d-flex align-items-center'>
			// 				<span className={`badge`} style={{ backgroundColor: bgColor, color: txColor }}>
			// 					{row.original.status_guide?.name
			// 						? row.original.status_guide.name
			// 						: ''}
			// 				</span>
			// 			</div>
			// 		);
			// 	},
			// },
			{ header: 'Origen', accessorKey: 'establishment.name', size: 'auto', },
			// {
			// 	header: 'Empresa',
			// 	accessorKey: 'establishment.company.name',
			// 	 size: 'auto',
			// },
			// {
			// 	header: 'Bodega transitoria',
			// 	accessorKey: 'warehouse.name',
			// 	 size: 'auto',
			// },
			{ header: 'Destino Final', accessorKey: 'final_destination.name', size: 'auto', },
			// { header: 'Kg Recibidos', accessorKey: 'kilograms_received',  size: 'auto' },
			{ header: 'Kg por Recibir', accessorKey: 'kilograms_sended', size: 'auto' },
			{ header: 'Kg por Recepcionar', accessorKey: 'kilograms_to_receive', size: 'auto' },
			// { header: 'Kg Certificados', accessorKey: 'kilograms_certified',  size: 'auto' },
			{ header: 'Factura', accessorKey: 'invoce', size: 'auto', visible: false },
			{ header: 'IVA', accessorKey: 'iva', size: 'auto', visible: false },
			{ header: 'Subtotal', accessorKey: 'subtotal', size: 'auto', visible: false },
			{ header: 'Total', accessorKey: 'total', size: 'auto', visible: false },
			{ header: 'Observación', accessorKey: 'observation', size: 'auto', visible: false },
		],
		[handleClickEdit]
	);


	const [goToSelectionItemsTable, setGoToSelectionItemsTable] = useState(false);

	const handlerGoToSelectionList = () => {
		setGoToSelectionItemsTable(!goToSelectionItemsTable);
	}

	function checkKilogramsToReceive() {
		const itemsWithoutKilograms = guideSelectedList.filter(
			item => item.kilograms_to_receive == null
		);

		return (
			itemsWithoutKilograms.length == 0
				? true : false
		)
	}

	const [isOpenConfirmReceptionModal, setIsOpenConfirmReceptionModal] = useState(false);

	function handlerToggleConfirmReceptionModal() {
		const isOkKilograms = checkKilogramsToReceive();
		if (isOkKilograms) {
			setIsOpenConfirmReceptionModal(!isOpenConfirmReceptionModal);
		} else {
			toast.error(
				'Debe especificar los kilogramos a enviar a todos los residuos antes de enviar.',
				{ autoClose: 4000 }
			);
		}
	}

	function handlerUpdateGuide(guide) {
		setGuideSelectedList(guideSelectedList.map((item) => {
			if (item._id == guide._id) {
				return { ...item, ...guide };
			} else {
				return item;
			}
		}));
	}

	// Effect to manage toggle modal by reducer state require
	useEffect(() => {
		if (isOpenConfirmReceptionModal) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handlerToggleConfirmReceptionModal();
			}
		}
	}, [requireCloseModal]);

	// Effect to manage reload grid by reducer state require
	useEffect(() => {
		if (requireReloadSelectionItemsGrid) {
			dispatch(setRequireReloadSelectionItemsGrid(false))
			dispatch(getGuideList({ reception_final_destination: true }));
			setSelectionReceiveList({});
			setGuideSelectedList([]);
			setGoToSelectionItemsTable(false);
		}
	}, [requireReloadSelectionItemsGrid]);

	useEffect(() => {
		if (selectionReceiveList) {
			let selectionItems = [];
			Object.entries(selectionReceiveList).forEach(([key, value]) => {
				if (key != null) {
					selectionItems.push(guideList.find(item => item._id == key));
				}
			})
			setGuideSelectedList(selectionItems);
		}

	}, [selectionReceiveList])

	return (
		<React.Fragment>
			<div className='row'>
				<Col lg={12}>
					<div className='card'>
						<div className='card-header border-0'>
							<div className='d-flex align-items-center'>
								<h5 className='card-title mb-0 flex-grow-1'>
									{(goToSelectionItemsTable ? 'Lista de guías seleccionadas para recepcionar' : '')}
								</h5>
								<div className='flex-shrink-0'>
									<div className='d-flex flex-wrap gap-2'>
										<button
											className='btn btn-label btn-primary'
											onClick={handlerGoToSelectionList}
											disabled={(guideSelectedList.length || goToSelectionItemsTable && guideSelectedList.length == 0 ? false : true)}
										>
											<i className={`ri-arrow-${(!goToSelectionItemsTable ? 'right' : 'left')}-line label-icon`}></i>{' '}
											{(!goToSelectionItemsTable ? 'Ir a guías seleccionadas' : 'Volver a guías por recepcionar')}
											{!goToSelectionItemsTable ?
												<Badge color="white" pill className='mx-1'>
													<div className='text-primary fw-bold p-0 m-0'>{guideSelectedList.length}</div>
												</Badge>
												:
												null
											}
										</button>
									</div>
								</div>
							</div>
						</div>

						<div className={`p-3 ${(goToSelectionItemsTable ? 'd-none' : '')}`}>
							<ODataGrid
								columns={columnsTableReceive}
								data={guideList || []}
								getRowIdTable={(originalRow) => originalRow._id}
								selectAllMode={'all'}
								selection={{
									rowSelection: selectionReceiveList,
									setRowSelection: setSelectionReceiveList,
								}}
								isLoadingData={isLoadingList}
							/>
						</div>
						<div className={`p-3 ${(!goToSelectionItemsTable ? 'd-none' : '')}`}>
							<ODataGrid
								columns={columnsTableToReceived}
								data={guideSelectedList || []}
								getRowIdTable={(originalRow) => originalRow._id}
							/>
							<div className='w-100 d-flex flex-row-reverse gap-2 my-4'>
								<button
									className='btn btn-label btn-primary'
									onClick={() => handlerToggleConfirmReceptionModal()}
									disabled={(guideSelectedList.length ? false : true)}
								>
									<i className={`${Icons.check} label-icon`}></i>{' '}
									Recepcionar Residuos
								</button>
							</div>
						</div>
					</div>
				</Col>
			</div>
			<ConfirmReceptionFinalDestinationModal
				guidesReception={guideSelectedList}
				isOpen={isOpenConfirmReceptionModal}
				handlerToggleModal={handlerToggleConfirmReceptionModal}
			/>
			<EditKilogramsReceivedModal
				dataGuide={dataGuide}
				isOpen={isOpenEditKilogramsReceivedGuideModal}
				handlerToggleModal={handlerToggleEditKilogramsReceivedGuideModal}
				handlerUpdateGuide={(guide) => {
					handlerUpdateGuide(guide);
				}}
			/>
			{selectedGuideId && (
				<GuideDetail
					info={selectedGuideId}
					isOpen={modalGuideDetail}
					toggle={toggleModal}
				/>
			)}
		</React.Fragment>
	);
};

export default ReceptionGuide;